module.exports = __webpack_public_path__ + "static/media/4.afa10539.jpg";